import styled from "styled-components";

export const ButtonContainer = styled.div`
  display: block;
  align-items: center;
`;

export const DivContainer = styled.div`
  margin-left: 5px;
  display: inline-flex;
`;
